import { FC, useCallback } from 'react'
import { useSelector } from 'react-redux'

import { useAppDispatch } from 'cng-common/hooks/useAppDispatch'

import {
  fYearSelected,
  selectBusinessPrioritiesSelectedFYear,
  selectIsBusinessPrioritiesPreviousFYearSelected,
} from '../../model'
import { BusinessPrioritiesExportButton } from '../businessPrioritiesExportButton'
import { BusinessPrioritiesFYearSelect } from '../businessPrioritiesFYearSelect'

import styles from './BusinessPrioritiesControls.module.scss'

export const BusinessPrioritiesControls: FC = () => {
  const dispatch = useAppDispatch()
  const fYear = useSelector(selectBusinessPrioritiesSelectedFYear)
  const isPreviousFYear = useSelector(selectIsBusinessPrioritiesPreviousFYearSelected)

  const onFYearChange = useCallback(
    (value: number) => {
      dispatch(fYearSelected(value))
    },
    [dispatch]
  )

  return (
    <div className={styles.root}>
      <BusinessPrioritiesFYearSelect fYear={fYear} onChange={onFYearChange} />

      <div className={styles.actions}>
        {/* The export view always returns the current FY, so it is only available for it. */}
        <BusinessPrioritiesExportButton fYear={fYear} isDisabled={isPreviousFYear} />
      </div>
    </div>
  )
}

BusinessPrioritiesControls.displayName = 'BusinessPrioritiesControls'

export default BusinessPrioritiesControls
